import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { GridApi, ICellRendererParams, IRowNode } from '@ag-grid-community/core';
import { NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  effect,
  inject,
} from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

import {
  ExtendableDropdownOption,
  ExtendableOptionsDropdownComponent,
} from '@shared/components/extendable-options-dropdown/extendable-options-dropdown.component';
import { LaunchDarklyService } from '@shared/services/launch-darkly.service';

import { MapActivitiesGridRow } from '../map-activities-modal.model';
import {
  MapActivitiesLineItemOption,
  MapActivitiesModalService,
} from '../map-activities-modal.service';

export type AgExtendableOptionsDropdownParams = ICellRendererParams & {
  validateCell: (isInvalidValue: boolean, data: MapActivitiesGridRow, node: IRowNode) => void;
};

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, ExtendableOptionsDropdownComponent, NgSelectModule, NgClass],
  selector: 'aux-ag-extendable-options-dropdown',
  styleUrl: './ag-extendable-options-dropdown.component.scss',
  templateUrl: './ag-extendable-options-dropdown.component.html',
})
export class AgExtendableOptionsDropdownComponent implements ICellRendererAngularComp {
  changeDetectorRef = inject(ChangeDetectorRef);
  launchDarklyService = inject(LaunchDarklyService);
  mapActivitiesModalService = inject(MapActivitiesModalService);

  formControl = new FormControl(null);
  gridApi!: GridApi;
  isAutoMapActivityAmount = this.launchDarklyService.$select(
    (flags) => flags.automap_amount_invoice_activity
  );
  params!: AgExtendableOptionsDropdownParams;
  updateOptions = effect(() => {
    this.mapActivitiesModalService.invoiceItemOptions();
  });

  agInit(params: AgExtendableOptionsDropdownParams): void {
    this.params = params;
    this.gridApi = params.api;
    this.formControl.setValue(params.value);
  }

  getValue() {
    return this.formControl.value;
  }

  get initialSearchTerm(): string {
    return '';
  }

  noAction(): void {}

  onAddOption(option: ExtendableDropdownOption): void {
    this.onChange();
    this.mapActivitiesModalService.addInvoiceItemOptions(option);
    this.params.api.refreshCells({ force: true });
  }

  onChange(newValueOption?: MapActivitiesLineItemOption | string): void {
    if (typeof newValueOption !== 'string') {
      if (this.isAutoMapActivityAmount() && newValueOption?.isExistingItem) {
        this.params.node.updateData({
          ...this.params.node.data,
          amount: newValueOption.initialItemValue,
          invoice_item_description: this.formControl.value,
        });
      } else {
        this.params.node.updateData({
          ...this.params.node.data,
          invoice_item_description: this.formControl.value,
        });
      }
    }

    this.params.validateCell(
      !this.params.data.amount || !this.params.data.activity_id,
      this.params.node.data,
      this.params.node
    );
  }

  refresh(): boolean {
    return false;
  }

  stopEditing(): void {
    this.changeDetectorRef.detectChanges();
  }
}
